require('./image/knockadoor_logo.svg');
require('./image/green.svg');
require('./image/main-image-1.png');
require('./image/main-image-2.png');
